import { useQuery } from '@tanstack/react-query';
import taskTemplateService from '@services/taskTemplate';

export const TASK_TEMPLATES_QUERY_KEY = 'taskTemplates';

export const useTaskTemplates = () => {
  return useQuery({
    queryKey: [TASK_TEMPLATES_QUERY_KEY],
    queryFn: () => taskTemplateService.getTaskTemplates(),
    staleTime: 5 * 60 * 1000,
  });
};

export default useTaskTemplates;
